export default function PrimaryButton({ children, disabled, onClick, type = "button" }) {
  return (
    <button className="ir-primary" type={type} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}
